export var subTitle = 'flex flex-row justify-start items-center  w-full truncate';
export var icon = function (iconColor) { return "h-5 w-5 text-".concat(iconColor); };
export var container = function (backgroundColor, dividerType, dividerColor) {
    return "w-full flex flex-row justify-between items-center bg-".concat(backgroundColor, " cursor-pointer py-3 px-4 border-t border-").concat(dividerColor, " border-").concat(dividerType, " ");
};
//# sourceMappingURL=base-list-item.styles.js.map